import { ProductBadgeBase } from '../ProductBadgeBase';
import { ProductTimeHelper } from '../../ProductCard/utils/ProductTimeHelper';
import { ProductBadgeHelper } from '../ProductBadgeHelper';
import {
  ProductBadgeColorVariants,
  ProductBadgeShape,
  ProductBadgeStyleHelper,
} from '../ProductBadgeStyleHelper.ts';

export class PeriodLimitedBadge extends ProductBadgeBase<Date> {
  protected setLabel(): void {
    const diff = ProductTimeHelper.diffDate(this.data.value, new Date(this.data.server_timestamp));
    const options = { ...diff, lng: this.data.option.lang };

    if (this.isVisible()) {
      if (diff.day > 0) {
        this.label = ET('mps2::product::badge::period_limited_day', options);
        return;
      }
      if (diff.hour > 0) {
        this.label = ET('mps2::product::badge::period_limited_hour', options);
        return;
      }
      if (diff.minute > 0) {
        this.label = ET('mps2::product::badge::period_limited_minute', options);
        return;
      }
      if (diff.second >= 0) {
        this.label = ET('mps2::product::badge::period_limited_second', options);
      }
    }
  }

  isTimerNeeded(): boolean {
    return this.isVisible();
  }

  getIcon(): null {
    return null;
  }

  public override isVisible(): boolean {
    return ProductBadgeHelper.isPeriodLimitedBadgeLabelVisible(this.data.value, this.data.server_timestamp);
  }

  getTypo() {
    return ProductBadgeStyleHelper.getBaseTypo(this.data.option.size);
  }

  colorVariant(): ProductBadgeColorVariants {
    return ProductBadgeColorVariants.BLUE_TEXT;
  }

  shape() {
    return ProductBadgeShape.RECTANGLE;
  }
}
